// dependencies
import React from "react";

// components
import FilterChips, { type Filter } from "../../../../../../../components/FilterChips/FilterChips";

// types
import {
	CycleTypeSelectionOptions,
	type ReviewCycleRefreshFilter,
	StatusSelectionOptions,
} from "../ReviewCyclesFiltersRefresh";

const toLabels = (values: string[], options: { label: string; value: string }[]) =>
	values.map((value) => options.find((option) => option.value === value)?.label ?? value);

const convertFiltersToReadableList = (filters?: ReviewCycleRefreshFilter): Filter[] => {
	const readableList: Filter[] = [];

	if (filters?.type?.length) {
		readableList.push({
			id: "type",
			type: "string",
			label: "Type",
			value: toLabels(filters.type, CycleTypeSelectionOptions),
		});
	}

	if (filters?.status?.length) {
		readableList.push({
			id: "status",
			type: "string",
			label: "Status",
			value: toLabels(filters.status, StatusSelectionOptions),
		});
	}

	if (filters?.reviews360?.length) {
		readableList.push({
			id: "reviews360",
			type: "string",
			label: "360 Reviews",
			value: "Enabled",
		});
	}

	return readableList;
};

type ReviewCyclesReadableFiltersRefreshProps = {
	filters: ReviewCycleRefreshFilter;
	setFilters: (newFilters: ReviewCycleRefreshFilter) => void;
};

/** Applied-filter chips for the refreshed Review Cycles table. */
const ReviewCyclesReadableFiltersRefresh = ({ filters, setFilters }: ReviewCyclesReadableFiltersRefreshProps) => {
	const convertedFilters = convertFiltersToReadableList(filters);

	if (convertedFilters.length === 0) {
		return null;
	}

	return (
		<div>
			<FilterChips
				filters={convertedFilters}
				label="Filters applied: "
				onDeleteFilter={(id) => {
					setFilters({ ...filters, [id]: undefined });
				}}
			/>
		</div>
	);
};

export default ReviewCyclesReadableFiltersRefresh;
